import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ls } from "../strings.js";
// this isn't used externally
// eslint-disable-next-line jsdoc/require-jsdoc
export const Divider = () => {
    return (_jsxs("div", { className: `flex flex-row gap-3 w-full items-center text-fg-tertiary`, children: [_jsx("div", { className: `h-[1px] bg-static basis-full shrink grow` }), _jsx("p", { children: ls.login.or }), _jsx("div", { className: `h-[1px] bg-static basis-full shrink grow` })] }));
};
//# sourceMappingURL=divider.js.map